module.exports = __webpack_public_path__ + "static/blackCurtain-315826a6f91f8d4309e09bacac571bd5.jpg";